import { render, staticRenderFns } from "./JobModule.vue?vue&type=template&id=20719f02&scoped=true&"
import script from "./JobModule.vue?vue&type=script&lang=js&"
export * from "./JobModule.vue?vue&type=script&lang=js&"
import style0 from "./JobModule.vue?vue&type=style&index=0&id=20719f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20719f02",
  null
  
)

export default component.exports